export * from './cloud.component';